import { Controller as BaseController } from 'stimulus'
import { setCookie } from '@app/javascript/classes/cookies'

export class Controller extends BaseController {
  searchKeywordsChanged(event) {
    const { searchKeywords } = event.detail
    const hasSearchKeywords = !!(searchKeywords?.trim())

    if (hasSearchKeywords) {
      this.sortingControlsController.selectSort(
        'relevancy',
        'desc'
      )
    }
  }

  sortingTriggered(event) {
    this.rememberSelections(event.detail)
  }

  rememberSelections({ field, dir }) {
    setCookie('searchPage.sortField', field, { longLasting: true, path: '/' })
    setCookie('searchPage.sortDir', dir, { longLasting: true, path: '/' })
  }

  get sortingControlsController() {
    return this.element.controllers['shared--sorting-controls']
  }
}
